// extracted by mini-css-extract-plugin
module.exports = {"ui_loader":"Loader_ui_loader__1z7aq","spin":"Loader_spin__3SFrF","ui_loader_xs":"Loader_ui_loader_xs__2CwMZ"};